<template>
  <v-container fluid grid-list-md class="pb-0 mb-0">
    <JumboTron v-if="buddies.length === 0"/>

    <div class="pl-4 mt-10">
      <v-container fluid>
        <v-row align="center" justify="center">
          <template>
            <draggable v-if="superLightView" :disabled="canDrag" class="d-flex row align-center justify-start"
              @change="buddyMoved" :value="buddies" ghost-class="card-ghost">
              <div v-for="(buddy, idx) in buddies" :key="idx">
                <BuddyLightItem :buddy="buddy" :superLightItemSize="superLightItemSize"/>
              </div>
            </draggable>
            <draggable v-else :disabled="canDrag" class="d-flex row align-center justify-start"
              @change="buddyMoved" :value="buddies" ghost-class="card-ghost">
              <div v-for="(buddy, idx) in buddies" :key="idx">
                <BuddyCard :buddy="buddy"/>
              </div>
            </draggable>
          </template>
        </v-row>
      </v-container>
    </div>
    <v-btn
      class="mb-10"
      absolute
      fab
      bottom
      right
      v-if="embedded"
      @click="reloadPage()"
    >
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import BuddyCard from './buddy_card'
import BuddyLightItem from './buddy_light_item'
import JumboTron from './jumbotron'
import EmbeddedLocalStorage from '@/api/embedded'

export default {
  name: 'buddies',
  data () {
    return {
      availableStatus: ['isOnCall', 'isRinging', 'isOnline', 'isBusy', 'isAway', 'isOffline']
    }
  },
  components: { draggable, BuddyCard, JumboTron, BuddyLightItem },
  computed: {
    ...mapGetters({
      buddiesRaw: 'users/buddies',
      compactView: 'users/compactView',
      superLightView: 'users/superLightView',
      superLightItemSize: 'users/superLightSize',
      sort: 'users/sort',
      getSearchText: 'search/searchText',
      sLightSize: 'users/superLightSize',
      currentUser: 'chat/authenticatedRocketChatUser' // chat user
    }),
    draggable () {
      return this.sort?.match('custom')
    },
    canDrag () {
      return !this.draggable || this.$vuetify.breakpoint.mobile
    },
    sortDirection () {
      const split = this.sort?.split('_')
      if (split.length > 1) {
        return this.sort?.split('_')[1]
      }
      return 'asc'
    },
    sortBy () {
      const sortWithDirection = this.sort
      if (sortWithDirection.match('_')) {
        return sortWithDirection.split('_')[0]
      }
      return this.sort
    },
    embedded () {
      return EmbeddedLocalStorage.get()
    },
    buddies () {
      const data = this.buddiesRaw.filter(buddy => {
        const searchRegexp = new RegExp(this.getSearchText, 'i')
        return buddy.name.match(searchRegexp) ||
        buddy.exten.match(searchRegexp) ||
        buddy.department.match(searchRegexp)
      })
      switch (this.sortBy) {
        case 'custom':
          break
        case 'extension':
          data.sort((a, b) => a.exten - b.exten)
          break
        case 'name':
          data.sort((a, b) => a.name.localeCompare(b.name))
          break
        case 'status':
          data.sort((a, b) => {
            for (let i = 0; i < this.availableStatus.length; i++) {
              const status = this.availableStatus[i]
              if (a[status] && !b[status]) {
                return -1
              } else if (!a[status] && b[status]) {
                return 1
              }
            }
          })
          break
      }
      return this.sortDirection === 'desc' ? data.reverse() : data
    }
  },
  watch: {
    async buddies () {
      await this.initSearch(this.$t('buddy.searchPlaceholder'))
    }
  },
  methods: {
    ...mapActions({
      initSearch: 'search/init',
      closeSearch: 'search/close',
      buddyMoved: 'users/buddyMoved',
      getDirectMessages: 'chat/getDirectMessages',
      chatAuth: 'chat/auth'
    }),

    reloadPage () {
      window.location.reload()
    }
  },
  async mounted () {
    if (!this.currentUser) {
      await this.chatAuth()
    }
    this.getDirectMessages()
  }
}
</script>

<style>
.card-ghost {
  opacity: 0.3;
  background: #CCC !important;
  border: 1px solid #CCC !important;
}
</style>
